/**
 * created by trj
 * 统计表 页面
 */
import React, {Component} from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {Empty, Tabs,message,Modal} from "antd";
import StatisticsTable from "./components/table/statisticsTable";
import Page from "./components/page/page";
// import Adapter from './cascader'; // 导入适配器函数
import {getOffsetHeight} from "./utils";
import RenderSearch from "./components/search/renderSearch";
import  {contentParser} from "../../../base/BaseComponent";
const { TabPane } = Tabs;

export default class Statistics extends BaseComponent{
    static defaultProps = {
        windowHeight: document.body.clientHeight,
        tabsHeight: 0,
        searchHeigh: 0,
        pageHeight: 73,
        marginHeight: 30,
        headerHeight: 70,
        paddingHeight: 12,
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            params:{},
            count:0,
            data:[],
            tabKey:"0",
            config: {},
        };
        this.setDefaultState()
    }

    setDefaultState = () => {
        if(this.props.defaultStateData) {
            this.state = {
                ...this.state,
                ...JSON.parse(JSON.stringify(this.props.defaultStateData))
            }
        }
    }
    componentWillMount() {

        if (this.props.config) {
          // 如果 props 中已经传递了 config 对象，则调用 getConfigByProps
          this.getConfigByProps(this.props.config);
        } else {
          const { configName } =this.props.match.params;
          this.getConfig(configName);
        }
      }
      
      getConfigByProps = (config) => {

        this.state.config=JSON.parse(JSON.stringify(config))
        let tabKey = config?.nav?.[0]?.key;
        this.getCurrentParam(tabKey)

        // this.setState({
        //     config: config
        // }, () => {
        //     let tabKey = this.state.config?.nav?.[0]?.key;
        //     this.getCurrentParam(tabKey);
        // });
        // this.setState((prevState) => ({
        //     ...prevState,
        //     config: config
        // }), () => {
        //     let tabKey = this.state.config?.nav?.[0]?.key;
        //     this.getCurrentParam(tabKey);
        // }); 
      }
    
    getConfig = (key) => {

        this.key = key;
        if (!key || (typeof key !== "string")) return console.log("字段不合法");
        let config = null;
        try {
            config = require(`./config/${key}`)?.config;
        } catch (e) {
            console.log(e.toString())
        }
        this.state.config=config;
        let tabKey = config?.nav?.[0]?.key;
        this.getCurrentParam(tabKey)
    };

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(this.props.match.params.configName !== nextProps.match.params.configName) {
            this.setState({data:[],count:0})
            let key = nextProps.match.params.configName ? nextProps.match.params.configName : '';
            this.getConfig(key)
        }
    }

    /**
     * 保存配置项里面的参数
     * @param {string} tabKey 当前tabkey
     * @param {fun} call 回调
     */
    getCurrentParam(tabKey="0",call){
        this.state.dataSource = [];
        this.state.total = 0;
        this.state.tabKey = tabKey;
        let thisTab = {};
        try {
            thisTab = this.state.config.nav.find(item=>item.tabKey===tabKey);
        } catch (e) {
            console.log(e.toString())
        }
        let request = thisTab?.request ? {...thisTab?.request} : {};
        let params = request?.params ? {...request?.params} : {};
        if(this.props&&this.props.data&&this.props.data.mediaFusionId){
            params.mediaFusionId=this.props.data.mediaFusionId
        }
        if(this.props.defaultStateData?.params) {
            this.state.params = {...this.state.params,...params};
        }else {
            this.state.params = {...params};
        }
        this.state.request = request;
        this.setState({})
        call&&call()
    }

    /**
     * 列表查询
     */
    getDataSource = () => {
        const {request,params} = this.state;
        let url = request?.url;
        let method = request?.method || "get";
        let contentType = request?.contentType;
        let paramsConfig = request?.paramsConfig;
        let resConfig = request?.resConfig;
        if(url && method && params) {
            this.request({
                url,
                method,
                contentType,
                loading:true,
                body: params,
                callBack: (res)=>{
                    let data = [];
                    let count = 0;
                    if(res?.[resConfig?.count]) {
                        count = res[resConfig.count]
                    }
                    if(res?.[resConfig?.data]) {
                        data = res[resConfig.data]
                    }
                    let formatData = this.formatData(data);
                    this.setState({count,data:formatData});
                },
                errorCallBack: (e)=>{
                    console.log(e.toString())
                }
            });
        }
    };
    /**
     * 对表格数据进行格式化（添加索引）
     * @param {array} data 列表数据
     */
    formatData = (data) => {
        let newData = [];
        let {request} = this.state;
        let {paramsConfig={size: "pageSize",page: "pageNum",}} = request;
        if(data?.length && paramsConfig) {
            let size = this.state.params[paramsConfig.size];
            let page = this.state.params[paramsConfig.page];
            newData = data.map((item,index)=>({
                ...item,
                index: (index+1) + (size * (page-1))
            }))
        }
        return newData
    };
    /**
     * table操作（排序、筛选）后的回调
     * @param {object} pagination 翻页参数
     * @param {object} filters 筛选参数
     * @param {object} sorter 排序参数
     */
    handleTableChange = (pagination,filters, sorter) => {
        let {request} = this.state;
        let {paramsConfig={size: "pageSize",page: "pageNum",sort: {}}} = request;
        // 排序字段
        let sortField = sorter.field;
        // 排序方式 ascend 上升 descend 下降
        let sortOrder = sorter.order;
        let order = paramsConfig?.sort?.order;
        let orderKey = order?.key;
        let orderList = order?.select;
        let orderValue = orderList?.[sortOrder];
        let field = paramsConfig?.sort?.field;
        this.state.params[field] = sortField;
        this.state.params[orderKey] = orderValue;
        if (!this.state.params.sort) {
            this.state.params.order = ""
            this.state.params.sort = ""
        }
        this.getDataSource()
    };
    /**
     * tab切换回调
     * @param {string} activeKey 切换后的tabkey
     */
    tabChange = (activeKey) => {

        this.getCurrentParam(activeKey,()=>{
            // this.getDataSource();
            this.setState({},()=>{
            })
        })
    };

    /**
     * 点击搜索的回调
     * @param {object} params 最新的查询参数
     */
    onSearch = (params) => {

        let {request} = this.state;
        let {paramsConfig} = request;
        let {defaultParams} = request;
        let pageKey = paramsConfig?.page;
        let newParams = {
            ...this.state.params,
            ...params,
            [pageKey]:defaultParams[pageKey]
        };

        if(this.props&&this.props.data&&this.props.data.mediaFusionId){
            newParams.mediaFusionId=this.props.data.mediaFusionId
        }
        this.state.params = {...this.state.params,...newParams};
        this.getDataSource();
    };
    /**
     * 点击导出的回调
     * @param {object} params 导出接口需要的特殊参数
     */
    onExport = ({url,method,contentType,params={}}) => {
        let newParams = {...this.state.params,...params};
        if(url && method && newParams) {
            this.request({
                url,method,contentType,body:newParams,loading:true,
                callBack: (res)=>{

                }
            })
        }
    };
    /**
     * 缓存参数回退到上次搜索的时刻
     * @param {function} call 回调
     */
    rollback = (call) => {
        if(typeof this.search?.rollback === "function") {
            this.search.rollback()
        }
    };
    /**
     * 翻页或改变页容量的回调
     * @param {number} current 页码
     * @param {number} pageSize 页容量
     */
    onPageChange = ({current,pageSize}) => {

        this.rollback();
        let {request} = this.state;
        let {paramsConfig={size: "pageSize",page: "pageNum",}} = request;
        this.state.params[paramsConfig.size] = pageSize;
        this.state.params[paramsConfig.page] = current;
        this.getDataSource()
    };
    tabsHeight = this.props.tabsHeight;
    renderTab = (nav) => {
        let tab = "";
        if(nav?.length > 1) {
            this.tabsHeight = 40;
            tab = <Tabs
                type="card"
                key={"Tabs"}
                onChange={(activeKey)=>{this.tabChange(activeKey)}}
            >
                {
                    nav.map(item =>
                        <TabPane tab={item?.name} key={item?.tabKey} style={{backgroundColor: '#fff'}}>
                        </TabPane>
                    )
                }
            </Tabs>
        }
        if(nav?.length === 1) {
            this.tabsHeight = 0;
            tab = <>
            </>
        }
        return (
            <div className={"selection_tabs"}>
                {tab}
                <style>
                    {`
                    .selection_tabs .ant-tabs-nav {margin-left: 32px}
                    .selection_tabs .ant-tabs-bar {margin-bottom: 20px}
                    `}
                </style>
            </div>
        )
    };
    searchHeight = this.props.searchHeigh;
    renderSearch = (renderSearch) => {
        let {tabKey} = this.state;
        let defaultState = renderSearch?.defaultState;
        let propsData = JSON.parse(JSON.stringify(defaultState || {}));
        try {
            contentParser(propsData, {state: this.state});
        } catch (e) {
            console.error(e)
        }


        return <RenderSearch
            config={renderSearch}
            defaultStateData={propsData}
            onSearch={this.onSearch}
            onExport={this.onExport}
            onResize={(offsetHeight)=>{
                if(this.searchHeight != offsetHeight) {
                    this.searchHeight = offsetHeight;
                    this.setState({});
                }
            }}
            ref={(ref) => {
                this.search = ref;
            }}
            key={"Search"+tabKey}
        />
    };
    evalTransition = (evalStr,width,item) => {
        let fun = eval(evalStr);
        return  (text,record) => {return fun(text,record,width,item)}
    };
    renderTable = (renderTable) => {
        let {tabKey} = this.state;
        let {data} = this.state;
        let columns = renderTable?.columns || [];
        columns.forEach((item, index) => {
                if(/^\${[a-zA-Z.]*}$/.test(item.render)){
                    let evalStr = item.render.replace(/^\${([a-zA-Z.]*)}$/,'$1');
                    item.render=this.evalTransition(evalStr,item.width,item);
                    // item.render=eval(`item.render`);
                }
        });

        let defaultItemWidth = renderTable?.defaultItemWidth || 100;
        let {windowHeight=0, pageHeight = 0, tabsHeight = 0, searchHeight = 0, marginHeight = 0, headerHeight = 0, paddingHeight = 0} = this;
        return (
            <StatisticsTable
                key={"StatisticsTable"+tabKey}
                dataSource={data}
                columns={columns}
                tableHeight={windowHeight-(pageHeight + tabsHeight + searchHeight + marginHeight + headerHeight + paddingHeight)}
                defaultItemWidth={defaultItemWidth}
                handleTableChange={this.handleTableChange}
            />
        )
    };
    renderView = (text,record,width)=>{
        return <div
            style={{
                width: width-32, // 减去左右padding
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                cursor:'pointer',
                color:'#0050B3',
            }}
            onClick={()=>{this.previewCall(record)}}
        >
            {text}
        </div>
    };


    renderOpenModal = (text,record,width,item)=>{
        let config = item?.config;
        let modalComponet = config.modalComponet;
        let ModalComponet = null;
        try{
            ModalComponet = require(`./components/modal/${modalComponet}`).default;
            // ItemComponent = require(`../components/btn/${componentItem.componentType}.js`).default;
        }catch(e){
            console.log(e.toString());
        }
        if(!ModalComponet) {
            return
        }
        return <div
            style={{
                width: width-32, // 减去左右padding
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                cursor:'pointer',
                color:'#0050B3',
            }}
        >
            <span  onClick={()=>{
                let props = config?.props;
                let propsData = JSON.parse(JSON.stringify(props || {}));
                try {
                    contentParser(propsData, {state: this.state});
                    contentParser(propsData, {record: record});
                } catch (e) {
                    console.error(e)
                }
                if(typeof this[`renderOpenModal{record.id}`]?.show === 'function'){
                    this[`renderOpenModal{record.id}`].show({config,propsData})
                }
            }}>{text}</span>
            {ModalComponet&&<ModalComponet ref={ref=>this[`renderOpenModal{record.id}`]=ref}/>}
        </div>
    };

    evalObj = (str) => {
        return eval(str)
    }


    renderTitle = (text,record,width) => {
        return <div
            style={{
                width: width-32, // 减去左右padding
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                wordWrap: 'break-word',
                wordBreak: 'break-word'
            }}
        >
            {text}
        </div>
    };
    pageHeight = this.props.pageHeight;
    windowHeight = this.props.windowHeight;
    renderPage = (renderPage={}) => {
        console.log(this.state.tabKey)
        let {request,tabKey} = this.state;
        let {paramsConfig={size: "pageSize",page: "pageNum",}} = request;
        let {resConfig={count: "count",data: "data"}} = request;
        let pageSize = this.state.params[paramsConfig.size];
        let current = this.state.params[paramsConfig.page];
        let count = this.state[resConfig.count];
        return <Page
            key={"Page"+tabKey}
            config={renderPage}
            total={count || 0}
            pageSize={pageSize || 10}
            current={current || 1}
            onShowSizeChange={this.onPageChange}
            onChange={this.onPageChange}
        />
    };
    marginHeight = this.props.marginHeight;
    headerHeight = this.props.headerHeight;
    paddingHeight = this.props.paddingHeight;

    render() {
        let {config,tabKey} = this.state;
        return (
            <div
                className={"renderTab"}
                style={{
                    maxHeight: 'calc(100vh - 100px)',
                    // minWidth: 1200,
                    margin: 15,
                }}
                key={config?.key}
            >
                {
                    config?.nav?.length > 0 ?
                        <>
                            {this.renderTab(config?.nav)}
                            <div style={{padding: "12px 32px 0px 32px",background: '#fff',
                                borderRadius: 5,
                                borderTopLeftRadius:config?.nav?.length == 1 ? 5 :(this.state.tabKey==="0"?0:5)
                            }}>
                                {this.renderSearch(config?.nav[tabKey]?.renderSearch)}
                                {this.renderTable(config?.nav[tabKey]?.renderTable)}
                                {this.state.data && this.state.data.length > 0 ? this.renderPage(config?.nav[tabKey]?.renderPage) : null}
                            </div>

                        </>
                        : <Empty/>
                }
                <style>
                    {
                        `.renderTab .selection_tabs .ant-tabs-nav {margin-left: 0;}
                         .renderTab .selection_tabs .ant-tabs-bar { margin-bottom: 0;}
                         .renderTab .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {border: none;}
                         .renderTab .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {background:transparent}
                         .renderTab .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {background: #fff;color: black !important;}
                         `
                    }
                </style>
            </div>
        )
    }

    //预览
    previewCall = (record) => {
        // this.request({
        //     url: '/cm-sites-pms/website/news/getPreviewParam',
        //     body: {contentId: record.contentId, webNewsId: record.webNewsId},
        //     callBack: (res) => {
        //         if (res) {
        //             console.log(res)
        //             debugger
        //             this.openPreviewPage(res.url,
        //                 {
        //                     account: res.account,
        //                     token: res.token,
        //                     action: res.action,
        //                     newsid: res.newsid,
        //                     type: res.type,
        //                     owners: res.owners,
        //                 }
        //             )
        //         }
        //     }
        // })
        this.request({
            url: '/cm-sites-storage-statistics/publish/link',
            body: {manuscriptId: record.manuscriptId, mediaId: record.mediaId},
            loading:true,
            callBack: (res) => {
                if (res) {
                    window.open(res.publishUrl, "_blank");
                }else{
                    message.destroy();
                    message.warning("暂未获取到发布链接！")
                }
            }
        })
    };

    //预览
    openPreviewPage(URL, PARAMTERS) {
        //创建form表单
        var temp_form = document.createElement("form");
        temp_form.action = URL;
        //如需打开新窗口，form的target属性要设置为'_blank'
        temp_form.target = "_self";
        temp_form.method = "post";
        temp_form.style.display = "none";
        temp_form.target = "_blank";
        //添加参数
        for (var key in PARAMTERS) {
            var opt = document.createElement("textarea");
            opt.name = key;
            opt.value = PARAMTERS[key];
            temp_form.appendChild(opt);
        }
        document.body.appendChild(temp_form);
        //提交数据
        temp_form.submit();
    };


}


